import { render, staticRenderFns } from "./changePsd.vue?vue&type=template&id=d2d97e64&scoped=true"
import script from "./changePsd.vue?vue&type=script&lang=ts"
export * from "./changePsd.vue?vue&type=script&lang=ts"
import style0 from "./changePsd.vue?vue&type=style&index=0&id=d2d97e64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d97e64",
  null
  
)

export default component.exports